import {AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {Overlayable} from "../../../interfaces/overlayable";
import {OverlayService} from "../../../overlay/overlay.service";
import {SelfAssessmentComponent} from "../self-assessment.component";
import {SelfAssessmentHeaderComponent} from "../self-assessment-header/self-assessment-header.component";
import {SelfAssessmentFooterComponent} from "../self-assessment-footer/self-assessment-footer.component";
import {SelfAssessmentService} from "../self-assessment.service";

@Component({
  selector: 'brt-self-assessment-intro',
  templateUrl: './self-assessment-intro.component.html',
  styleUrls: ['./self-assessment-intro.component.scss']
})
export class SelfAssessmentIntroComponent implements OnInit, Overlayable, AfterViewInit, OnDestroy {
  @ViewChild('dialogElement') dialogEl!: any;
  @Output('onClosed') onClosed = new EventEmitter<boolean>();

  constructor(private overlay: OverlayService, private selfAssessment: SelfAssessmentService) {
  }

  ngOnInit() {
    this.selfAssessment.setSelfAssessmentLocalStorage();
  }

  continue() {
    this.onClosed.emit(true);
    this.selfAssessment.goToStart();
    this.overlay.openWindowOverlay({
      componentMain: {component: SelfAssessmentComponent},
      componentHeader: {component: SelfAssessmentHeaderComponent},
      componentFooter: {component: SelfAssessmentFooterComponent},
      previousActiveElement: window.document.querySelector(".header__meta-item.header__meta-item--icon:has(.wizard-icon) button") as HTMLElement
    });
  }

  ngAfterViewInit() {
    console.warn("ngAfterViewInit")
    this.dialogEl?.nativeElement?.showModal();
  }

  ngOnDestroy() {
    this.dialogEl.nativeElement.close();
  }

  cancel() {
    this.onClosed.emit(true);
    const backElement = window.document.querySelector(".header__meta-item.header__meta-item--icon:has(.wizard-icon) button") as HTMLElement;
    backElement.focus();

  }
}
